import { useMemo, useState } from "react";

import { message } from "@src/constants";

import ShowErrorToastContext, {
  ShowErrorToastType,
} from "./showErrorToastContext";

const ShowErrorToastProvider = (props: { children: React.ReactNode }) => {
  const { children } = props;
  const initialState = {
    open: false,
    errorTitle: message.ERROR_MESSAGE,
    errorMessage: "",
  };
  const [showErrorToastState, showErrorToastSetState] =
    useState<ShowErrorToastType>(initialState);

  const stateValue = useMemo(
    () => [{ showErrorToastState, showErrorToastSetState }],
    [showErrorToastState, showErrorToastSetState]
  );

  return (
    <ShowErrorToastContext.Provider value={stateValue}>
      {children}
    </ShowErrorToastContext.Provider>
  );
};

export default ShowErrorToastProvider;
